import Service from "../../Services";

const Article = {
    namespaced : true,
    state : {
        allArticles: null,
        allEbooks: null,
        allOnlineExhibitions: null,
        article: {},
        onlineExhibition: {},
    },
    mutations : {
        setAllArticles(state, data) {
            state.allArticles = data;
        },
        setAllEbooks(state, data) {
            state.allEbooks = data;
        },
        setAllOnlineExhibitions(state, data) {
            state.allOnlineExhibitions = data;
        },
        setArticle(state, data) {
            state.article = data;
        },
        setOnlineExhibition(state, data) {
            state.onlineExhibition = data;
        }
    },
    actions : {
        onGetAllArticles({ commit }, { page, lang }) {
            return Service.ArticleAPI.getAllArticles({ page, lang }).then(res => {
                if (res.status == 200) {
                    commit('setAllArticles', res.data);
                }
            });
        },
        onGetAllEbooks({ commit }, { page, lang }) {
            return Service.ArticleAPI.getAllEbooks({ page, lang }).then(res => {
                if (res.status == 200) {
                    commit('setAllEbooks', res.data);
                }
            });
        },
        onGetAllOnlineExhibitions({ commit }, { branch, page, lang }) {
            return Service.ArticleAPI.getAllOnlineExhibitions({ branch, page, lang }).then(res => {
                if (res.status == 200) {
                    commit('setAllOnlineExhibitions', res.data);
                }
            });
        },
        onGetArticleById({commit}, { id, lang }) {
            return Service.ArticleAPI.getArticleById({ id, lang }).then(res => {
                if (res.status == 200) {
                    commit('setArticle', res.data);
                }
            });
        },
        onGetOnlineExhibitionsById({commit}, { id, lang }) {
            return Service.ArticleAPI.getOnlineExhibitionsById({ id, lang }).then(res => {
                if (res.status == 200) {
                    commit('setOnlineExhibition', res.data);
                }
            });
        }
    },
};

export default Article
